import { useEffect, useRef } from 'react';
import type { Standpoint } from '@fsv/core';
import { tx } from '@fsv/data';
import './StandpointPrompt.css';

/**
 * „Wo stehst du?“ over the top or bottom view, before a pin can be set
 * (owner, 17.10.2026: from the front you would otherwise have to think the
 * drawing round, and the damage lands on the wrong wing). It covers the board
 * so nothing is placed before the drawing lies the right way round.
 */
export function StandpointPrompt({ onPick }: { onPick: (at: Standpoint) => void }) {
  const first = useRef<HTMLButtonElement>(null);
  useEffect(() => first.current?.focus(), []);
  return (
    <div
      className="standpoint"
      role="group"
      aria-labelledby="standpoint-question"
      data-testid="standpoint-prompt"
    >
      <div className="standpoint__card">
        <h2 id="standpoint-question" className="standpoint__question">
          {tx.plan.standpoint.question}
        </h2>
        <p className="standpoint__why">{tx.plan.standpoint.why}</p>
        <div className="standpoint__choices">
          <button
            ref={first}
            type="button"
            className="btn btn--primary standpoint__choice"
            onClick={() => onPick('nose')}
          >
            <span className="standpoint__arrow" aria-hidden="true">
              ↓
            </span>
            {tx.plan.standpoint.nose}
          </button>
          <button
            type="button"
            className="btn btn--primary standpoint__choice"
            onClick={() => onPick('tail')}
          >
            <span className="standpoint__arrow" aria-hidden="true">
              ↑
            </span>
            {tx.plan.standpoint.tail}
          </button>
        </div>
      </div>
    </div>
  );
}
